import { render, staticRenderFns } from "./CutPage.vue?vue&type=template&id=3dcc6238&scoped=true&"
import script from "./CutPage.vue?vue&type=script&lang=js&"
export * from "./CutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc6238",
  null
  
)

export default component.exports